module.exports = __webpack_public_path__ + "fa-solid-900.d55c4d9df73c8874911e.svg";


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/scss/webfonts/fa-solid-900.svg
// module id = ../../../../../src/scss/webfonts/fa-solid-900.svg
// module chunks = styles